import React, { useEffect, useState } from 'react';
import { Card, Typography } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout';
import { setPasswordWithToken } from '../../services/auth';
import ChangePasswordForm from '../../components/ChangePasswordForm/ChangePasswordForm';

const { Text } = Typography;

export default function ResetPasswordPage() {
    const location = useLocation();
    const navigate = useNavigate();

    const [token, setToken] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [globalError, setGlobalError] = useState(null);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const t = params.get('token');
        if (!t) {
            setGlobalError('El enlace no es válido o le falta el token.');
        } else {
            setToken(t);
        }
    }, [location.search]);

    const handleSubmit = async (values) => {
        if (!token) return;

        setSubmitting(true);
        setGlobalError(null);

        try {
            const payload = {
                token,
                password: values.password,
            };

            await setPasswordWithToken(payload);

            setSuccess(true);

            setTimeout(() => {
                navigate('/login');
            }, 1500);
        } catch (error) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                'No se pudo guardar la nueva contraseña. Intenta de nuevo.';
            setGlobalError(message);
        } finally {
            setSubmitting(false);
        }
    };

    const isDisabled = !token || success;

    return (
        <AuthLayout>
            <Card
                style={{
                    maxWidth: 720,
                    width: '100%',
                    borderRadius: 24,
                    padding: '32px 40px',
                    boxShadow: '0 20px 60px rgba(15, 23, 42, 0.16)',
                }}
                bodyStyle={{ padding: 0 }}
            >
                <div style={{ padding: '8px 8px 24px' }}>
                    <ChangePasswordForm
                        onSubmit={handleSubmit}
                        loading={submitting}
                        error={globalError}
                        success={success}
                        successMessage="Tu contraseña se actualizó correctamente. En unos segundos serás redirigido a la pantalla de inicio de sesión."
                        disabled={isDisabled}
                        title="Reiniciar contraseña"
                    />

                    {!success && (
                        <div style={{ marginTop: 16, textAlign: 'center' }}>
                            <Text type="secondary" style={{ fontSize: 14 }}>
                                Si el enlace ya expiró, solicita uno nuevo con el administrador.
                            </Text>
                        </div>
                    )}
                </div>
            </Card>
        </AuthLayout>
    );
}